import React from "react";
import { BrowserRouter, Navigate, Route } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import TopLoader from "../Components/TopLoader";
import ScrollToTop from "../Components/ScrollToTop";
import Home from "../Pages/Home";
import NotFound from "../Pages/NotFound";
import About from "../Pages/About";
import Service1 from "../Pages/Service1";
import Service2 from "../Pages/Service2";
import HVAC from "../Pages/HVAC";
import Plumbing from "../Pages/Plumbing";
import Electrical from "../Pages/Electrical";
import LightCurrent from "../Pages/LightCurrent";
import Decoration from "../Pages/Decoration";
import Projects from "../Pages/Projects";
import ContactUs from "../Pages/Contact.jsx";
import Footer from "../Components/Footer/Footer.jsx";


const AppRouter = () => (
  <BrowserRouter>
    <ScrollToTop behavior="smooth" delay={100} />
    <Navbar />
    <main className="min-h-screen">
      <TopLoader>
        <Route path="" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/service1" element={<Service1 />} />
        <Route path="/service2" element={<Service2 />} />
        <Route path="/HVAC" element={<HVAC />} />
        <Route path="/Plumbing" element={<Plumbing />} />
        <Route path="/Electrical" element={<Electrical />} />
        <Route path="/LightCurrent" element={<LightCurrent />} />
        <Route path="/Decoration" element={<Decoration />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </TopLoader>
    </main>
    <Footer />
  </BrowserRouter>
);

export default AppRouter;
